var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2732 15.9859C19.0321 14.7952 19.4342 13.4121 19.432 12.0001C19.432 7.89729 16.1063 4.57157 12.0034 4.57157C10.5366 4.57157 9.16916 4.99672 8.01773 5.72986C7.25145 5.77284 6.49298 5.90673 5.7583 6.12872C6.55896 5.27509 7.52639 4.59499 8.60064 4.13055C9.6749 3.66611 10.8331 3.42723 12.0034 3.42872C16.7372 3.42872 20.5749 7.26643 20.5749 12.0001C20.5763 13.1705 20.3374 14.3287 19.8729 15.4029C19.4085 16.4771 18.7284 17.4446 17.8749 18.2453C18.0926 17.5236 18.2292 16.767 18.2732 15.9859Z",
    fill: "#B19C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3937 16.3447C18.98 17.0469 18.4686 17.6869 17.8749 18.2453C18.0926 17.5236 18.2292 16.767 18.2732 15.9859C19.0321 14.7952 19.4342 13.4121 19.432 12.0001C19.432 7.89729 16.1063 4.57158 12.0034 4.57158C10.5366 4.57158 9.16916 4.99672 8.01773 5.72986C7.25145 5.77284 6.49298 5.90674 5.7583 6.12872C6.31674 5.53503 6.95665 5.02364 7.65887 4.60986C8.97518 3.83423 10.4756 3.42632 12.0034 3.42872C16.7372 3.42872 20.5749 7.26643 20.5749 12.0001C20.5776 13.528 20.1696 15.0285 19.3937 16.3447Z",
    fill: "#B19C35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7817 12.916C22.3679 13.6182 21.8565 14.2582 21.2628 14.8166C21.4805 14.0949 21.6171 13.3383 21.6611 12.5571C22.42 11.3665 22.8222 9.9834 22.8199 8.57143C22.8199 4.46858 19.4942 1.14287 15.3914 1.14287C13.9245 1.14287 12.5571 1.56801 11.4057 2.30115C10.6394 2.34413 9.88092 2.47802 9.14624 2.70001C9.70468 2.10632 10.3446 1.59493 11.0468 1.18115C12.3631 0.405524 13.8636 -0.00239567 15.3914 1.05843e-05C20.1251 1.05843e-05 23.9628 3.83772 23.9628 8.57143C23.9655 10.0993 23.5576 11.5998 22.7817 12.916Z",
    fill: "#B19C35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 24C13.1944 24 17 20.1944 17 15.5C17 10.8056 13.1944 7 8.5 7C3.80558 7 0 10.8056 0 15.5C0 20.1944 3.80558 24 8.5 24ZM4.75 12.2734L6.11719 18H7.37109L8.50781 13.7188L9.64844 18H10.875L12.2656 12.2734H11.1016L10.2227 16.2734L9.21875 12.2734H7.84375L6.79688 16.207L5.93359 12.2734H4.75Z",
    fill: "#B19C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.738cf3e9b4a4443e8f5cea772db2b3a4.svg";
export { ForwardRef as ReactComponent };